// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"ab23b5d1","140":"76e7a0eb","416":"81088480","436":"0bff2c18","503":"3e05a233","528":"9bc08611","656":"4b70bc46","704":"26d31669"}[chunkId] + ".chunk.js";
};